import React, { useContext, useEffect, useState } from 'react'
import CustomImage from '../../components/customImage/customImage'
import deleteIcon from '../../assets/delete.png'
import shareIcon from '../../assets/share.png'
import favoriteIcon from '../../assets/add-wishlist-icon.svg'
import AddedToWishlist from '../../assets/added-wishlist-icon.svg'
import editIcon from '../../assets/edit.png'
import locationIcon from '../../assets/location-pin-svgrepo-com-2@3x.png'
import { AppContext } from '../../context/app'
import { isEmpty } from 'lodash'
import useTemplateHook from '../../components/template/templateHook'
import useAxios from 'axios-hooks'
import { ECOMMERCE_ORDER, PAYEMENT_ORGS, ECOMMERCE_API } from '../../utils/apiUrls'
import { useNavigate } from 'react-router'
import emptyCartIcon from '../../assets/empty-cart.png'
import { create_share_url, getProductImage, raiseToast, snakeToTitle } from '../../utils/helper'
import getSymbolFromCurrency from 'currency-symbol-map'
import ShareModal from '../../components/shareModal/shareModal'
import addIcon from '../../assets/add-address.png'
import { ContentContext } from '../../context/content'
import AddressModal from './addressModal'

const CartDetails = () => {
  const { getTemplateImage } = useTemplateHook()
  const { updateUserCart, userCart, userCartCall, setLoader, userObj, accountObj } =
    useContext(AppContext)
  const { addRemoveWishList, isInWishList } = useContext(ContentContext)
  const navigate = useNavigate()
  const [shareModal, setShareModal] = useState(false)
  const [selectedAddress, setSelectedAddress] = useState({})
  const [shippingChargesData, setShippingChargesData] = useState([])
  const [selectedShippingCharges, setSelectedShippingCharges] = useState({})
  const [openAddressModal, setOpenAddressModal] = useState(false)
  const isShippingChargesEnabled = accountObj?.od_resource_allowances?.is_shipping_charges_enabled

  const { products, total_discount, total_payable, total_price, currency } = userCart

  const [verifiedPaymentOrgs, setVerifiedPaymentOrgs] = useState([])
  const [showAddress, setShowAddress] = useState(false)

  const [{ data: paymentOrgList, loading: paymentOrgListLoading }] = useAxios({
    url: `${PAYEMENT_ORGS}/ecom`,
    method: 'get',
  })

  const [{ data: createOrderRes, loading: createOrderLoading }, createOrderCall] = useAxios(
    {
      url: `${ECOMMERCE_ORDER}/create`,
      method: 'post',
    },
    { manual: true },
  )

  const [{ data: shippingChargesInfo, loading: shippingChargesLoading }, shippingChargesCall] =
    useAxios(
      {
        url: ECOMMERCE_API + '/shipping-charges',
        method: 'get',
      },
      { manual: true },
    )

  useEffect(() => {
    setLoader(paymentOrgListLoading || createOrderLoading || shippingChargesLoading)
  }, [paymentOrgListLoading, createOrderLoading, shippingChargesLoading])

  useEffect(() => {
    userCartCall()
  }, [])

  useEffect(() => {
    if (isShippingChargesEnabled) {
      shippingChargesCall()
    }
  }, [isShippingChargesEnabled])

  useEffect(() => {
    if (shippingChargesInfo && shippingChargesInfo.success && !isEmpty(shippingChargesInfo?.data)) {
      let tempShippingData = []
      shippingChargesInfo?.data.forEach((element) => {
        element?.states.forEach((state) => {
          tempShippingData.push({
            ...element,
            state: state,
          })
        })
      })

      setShippingChargesData(tempShippingData)
    }
  }, [shippingChargesInfo])

  useEffect(() => {
    if (userObj && !isEmpty(userObj?.eccom_address)) {
      let tempDefaultObj = userObj?.eccom_address.find((item) => item.default)

      if (tempDefaultObj) {
        setSelectedAddress({ ...tempDefaultObj })
      } else {
        setSelectedAddress({ ...userObj?.eccom_address[0] })
      }
    }
    userCartCall()
  }, [userObj])

  useEffect(() => {
    if (isShippingChargesEnabled && !isEmpty(selectedAddress) && !isEmpty(shippingChargesData)) {
      let shippingChargeObj = shippingChargesData.find(
        (item) => item.state === selectedAddress.state,
      )
      setSelectedShippingCharges(shippingChargeObj)
    }
  }, [selectedAddress, shippingChargesData])

  useEffect(() => {
    if (createOrderRes && createOrderRes.success) {
      let { transaction_url } = createOrderRes.data

      window.location = transaction_url
    }
  }, [createOrderRes])

  useEffect(() => {
    if (paymentOrgList && paymentOrgList.success) {
      let tempData = paymentOrgList?.data.filter((item) => item.is_account_verified === true)
      setVerifiedPaymentOrgs([...tempData])
    }
  }, [paymentOrgList])

  const handlePlaceOrder = async () => {
    if (products && products.filter((item) => !item.in_stock).length > 0) {
      raiseToast('error', 'Remove out of stock products!')
      return
    }

    if (isEmpty(selectedAddress)) {
      raiseToast('error', 'Add Shipping Address')
      return
    }

    if (isShippingChargesEnabled && isEmpty(selectedShippingCharges)) {
      raiseToast('error', 'unable to fetch shipping charged')
      return
    }

    if (isEmpty(verifiedPaymentOrgs)) return

    let gatewayId = verifiedPaymentOrgs.find((item) => item.org === 'Stripe')._id
    let payload = {
      address: {
        ...selectedAddress,
      },
      customer_gateway_info: gatewayId,
    }

    if (isShippingChargesEnabled) {
      payload['shipping_charges'] = selectedShippingCharges.rate_amount
    }

    createOrderCall({
      data: {
        ...payload,
      },
    })
  }

  const EmptyCart = () => (
    <div className="flex justify-center items-center w-full">
      <div
        className="flex flex-col items-center justify-center px-4"
        style={{
          backgroundColor: '#1d2a39',
          borderRadius: '10px',
          minHeight: '327px',
          width: '637px',
        }}
      >
        {/* Cart Icon */}
        <div className="mb-6 md:mb-8 ">
          <img src={emptyCartIcon} alt="empty cart" className="h-12" />
        </div>

        <h2 className="text-white text-base md:text-lg lg:text-xl font-semibold mb-3 md:mb-4 text-center">
          Your Cart is currently <span style={{ color: '#ff6600' }}>Empty !</span>
        </h2>

        <p
          className="text-xs md:text-sm text-center max-w-md md:max-w-lg mb-8 md:mb-10 px-4"
          style={{ color: '#a1a1a1', maxWidth: '361px' }}
        >
          Before proceed to checkout you must add some products to your shopping cart.
        </p>

        <button
          className="px-20 py-2  text-white font-semibold rounded-md text-sm md:text-base lg:text-lg"
          style={{
            backgroundImage: 'linear-gradient(93deg, #f60 6%, #ff4e00 97%)',
          }}
          onClick={() => {
            navigate('/store')
          }}
        >
          Return to Shop
        </button>
      </div>
    </div>
  )

  return (
    <div className="w-full mt-2 xl:mt-4">
      <div className="max-w-[1269px] mx-auto px-4 sm:px-6 lg:px-8">
        {/* Heading + Address Icon */}
        <div className="flex items-center justify-between mb-6">
          <p className="text-white font-semibold text-sm md:text-lg lg:text-xl">
            Your Shopping Cart
          </p>
          {/* Mobile/Tablet icon */}
          {!isEmpty(products) && (
            <div
              className="lg:hidden flex items-center justify-center"
              style={{
                width: '36px',
                height: '28px',
                borderRadius: '4px',
                border: 'solid 0.5px #d1d1d1',
              }}
            >
              <img
                src={locationIcon}
                alt="address"
                className="w-4 h-5 object-cover cursor-pointer"
                onClick={() => setShowAddress((prev) => !prev)}
              />
            </div>
          )}
        </div>

        {isEmpty(products) ? (
          <EmptyCart />
        ) : (
          <div className="grid grid-cols-1 lg:grid-cols-3 lg:gap-8">
            {/* Price Details */}
            <div className="block lg:hidden">
              <div className="rounded-lg p-6 mb-5" style={{ backgroundColor: '#1d2a39' }}>
                <h3 className="text-white font-semibold text-sm md:text-base mb-4">
                  Price Details ({products?.length || 0} Items)
                </h3>
                <div className="mt-4">
                  <div className="flex justify-between items-center">
                    <p className="md:text-sm text-xs" style={{ color: '#a1a1a1' }}>
                      Total Price
                    </p>
                    <p className="md:text-sm text-xs" style={{ color: '#a1a1a1' }}>
                      {parseFloat(total_price).toFixed(2)}{' '}
                      {getSymbolFromCurrency(currency || 'USD')}
                    </p>
                  </div>
                  <div className="flex justify-between items-center mt-3">
                    <p className="md:text-sm text-xs" style={{ color: '#a1a1a1' }}>
                      Total Discount
                    </p>
                    <p className="md:text-sm text-xs" style={{ color: '#a1a1a1' }}>
                      - {parseFloat(total_discount).toFixed(2)}{' '}
                      {getSymbolFromCurrency(currency || 'USD')}
                    </p>
                  </div>
                  {isShippingChargesEnabled && !isEmpty(selectedShippingCharges) ? (
                    <div className="flex justify-between items-center mt-3">
                      <p className="md:text-sm text-xs" style={{ color: '#a1a1a1' }}>
                        Shipping Charges
                      </p>
                      <p className="md:text-sm text-xs" style={{ color: '#a1a1a1' }}>
                        + {parseFloat(selectedShippingCharges?.rate_amount).toFixed(2)}{' '}
                        {getSymbolFromCurrency(currency || 'USD')}
                      </p>
                    </div>
                  ) : null}
                  <hr className="border-gray-600 mt-3" />
                  <div className="flex justify-between items-center font-semibold mt-4">
                    <p className="text-white md:text-sm text-xs">Payable Amount</p>
                    <p className="text-white md:text-sm text-xs">
                      {isShippingChargesEnabled && !isEmpty(selectedShippingCharges)
                        ? parseFloat(total_payable + selectedShippingCharges?.rate_amount).toFixed(
                            2,
                          )
                        : parseFloat(total_payable).toFixed(2)}{' '}
                      {getSymbolFromCurrency(currency || 'USD')}
                    </p>
                  </div>
                </div>

                <button
                  className="mt-14 w-full mb-2 text-white font-semibold py-3 px-4 rounded-md md:text-lg text-sm"
                  style={{
                    backgroundImage: 'linear-gradient(93deg, #f60 6%, #ff4e00 97%)',
                    opacity: products?.length ? 1 : 0.8,
                  }}
                  disabled={!products?.length}
                  onClick={handlePlaceOrder}
                >
                  Place Order
                </button>
              </div>
            </div>

            {/* Left Side - Cart Items */}
            <div className="lg:col-span-2">
              {products.map((item, index) => (
                <div
                  key={item._id}
                  className="rounded-lg p-5 mb-3"
                  style={{ backgroundColor: `#1d2a39${item.in_stock ? '' : '50'}` }}
                >
                  {/* Desktop Layout */}
                  <div className="hidden md:flex items-start gap-4">
                    <div
                      className="text-white flex items-center justify-center text-xs rounded-md"
                      style={{
                        width: '24px',
                        backgroundColor: '#333c47',
                        height: '24px',
                        opacity: item.in_stock ? 1 : 0.5,
                      }}
                    >
                      {index + 1}
                    </div>
                    <div
                      style={{ opacity: item.in_stock ? 1 : 0.5 }}
                      className="bg-white rounded-lg flex items-center justify-center xl:h-40 lg:h-28 h-20 flex-shrink-0"
                    >
                      <CustomImage
                        imageUrl={getTemplateImage(getProductImage(item.img_s3_keys))}
                        imgAlt={item.title}
                        imgClass="w-full h-full object-cover cursor-pointer"
                        loaderClass="xl:h-40 lg:h-28 h-20 aspect-square"
                        onClickRedirect={() => navigate(`/product/${item._id}`)}
                      />
                    </div>

                    <div className="px-4 w-full">
                      <div className="flex justify-between items-start mb-2">
                        <p
                          style={{ opacity: item.in_stock ? 1 : 0.5 }}
                          className="text-white font-semibold text-base flex-1 line-clamp-2"
                        >
                          {item.title}
                        </p>
                        <div className="flex items-center gap-2 ml-5">
                          <img
                            src={shareIcon}
                            alt="share"
                            className="w-6 h-6 object-cover cursor-pointer"
                            onClick={() => setShareModal(true)}
                          />

                          {isInWishList(item._id) ? (
                            <img
                              src={AddedToWishlist}
                              alt="favorite"
                              className="w-6 h-6 object-cover cursor-pointer"
                              onClick={() => addRemoveWishList(item._id)}
                            />
                          ) : (
                            <img
                              src={favoriteIcon}
                              alt="favorite"
                              className="w-6 h-6 object-cover cursor-pointer"
                              onClick={() => addRemoveWishList(item._id)}
                            />
                          )}

                          <img
                            src={deleteIcon}
                            alt="delete"
                            className="w-6 h-6 object-cover cursor-pointer"
                            onClick={() =>
                              updateUserCart(
                                item._id,
                                0,
                                item?.is_variation_product ? item?.variation_id : '',
                              )
                            }
                          />
                        </div>
                      </div>

                      <div
                        style={{ opacity: item.in_stock ? 1 : 0.5 }}
                        className="flex items-center gap-4 mb-3"
                      >
                        {item.in_stock ? (
                          <div className="flex items-center gap-2">
                            <span className="text-white text-xs">Quantity: </span>
                            <div className="flex items-center rounded">
                              <div
                                className="flex items-center justify-center"
                                style={{
                                  backgroundColor: '#2a3644',
                                  borderTopLeftRadius: ' 21.5px',
                                  borderBottomLeftRadius: ' 21.5px',
                                }}
                              >
                                <button
                                  onClick={() =>
                                    updateUserCart(
                                      item._id,
                                      parseInt(Math.max(1, item.quantity - 1)),
                                      item?.is_variation_product ? item?.variation_id : '',
                                    )
                                  }
                                  className="px-3 text-base text-white"
                                >
                                  -
                                </button>
                              </div>

                              <div
                                className="flex items-center justify-center ml-1 mr-1"
                                style={{
                                  backgroundColor: '#2a3644',
                                }}
                              >
                                <span className="px-3 text-white">{item.quantity}</span>
                              </div>

                              <div
                                className="flex items-center justify-center"
                                style={{
                                  backgroundColor: '#2a3644',
                                  borderTopRightRadius: ' 21.5px',
                                  borderBottomRightRadius: ' 21.5px',
                                }}
                              >
                                <button
                                  onClick={() =>
                                    updateUserCart(
                                      item._id,
                                      parseInt(item.quantity + 1),
                                      item?.is_variation_product ? item?.variation_id : '',
                                    )
                                  }
                                  className="px-3 text-base text-white"
                                >
                                  +
                                </button>
                              </div>
                            </div>
                            {/* <select
                            value={item.quantity}
                            onChange={(e) => updateUserCart(item._id, parseInt(e.target.value))}
                            className="bg-transparent text-white px-3 py-1 rounded text-xs"
                            style={{ border: 'solid 0.5px #ccc' }}
                            disabled={!item.in_stock}
                          >
                            {Array.from({ length: 10 }, (_, i) => i + 1).map((num) => (
                              <option key={num} value={num} className="text-black">
                                {num}
                              </option>
                            ))}
                          </select> */}
                          </div>
                        ) : null}
                      </div>

                      <div
                        className={`text-sm font-semibold ${
                          !isEmpty(item?.metadata) ? 'mb-4' : 'mb-6'
                        } mt-3`}
                        style={{
                          color: item.in_stock ? '#52c90d' : '#ff4d4d',
                        }}
                      >
                        {item.in_stock ? 'In Stock' : 'Out of Stock'}
                      </div>
                      {!isEmpty(item?.metadata) ? (
                        <div className="flex items-center">
                          {Object.keys(item?.metadata).map((key, index) => {
                            return (
                              <div
                                className={index ? 'ml-2' : ''}
                                style={{ color: '#d1d1d1' }}
                                key={index}
                              >
                                <span className="text-xs">
                                  {item?.metadata[key].name}: {item?.metadata[key].value}
                                </span>
                              </div>
                            )
                          })}
                        </div>
                      ) : null}

                      {item.in_stock ? (
                        <div className="flex items-center gap-3">
                          <span className="text-xs" style={{ color: '#979797' }}>
                            Price:
                          </span>
                          <span className="text-white text-2xl font-semibold">
                            {item.discount.enabled
                              ? parseFloat(
                                  item.price - (item.price * item.discount.discount_value) / 100,
                                ).toFixed(2)
                              : parseFloat(item.price).toFixed(2)}
                          </span>
                          <span className="text-white text-base mt-2 uppercase">
                            {getSymbolFromCurrency(currency || 'USD')}
                          </span>
                          {item.discount.enabled && (
                            <span
                              className="line-through  mt-2 text-base"
                              style={{ color: '#808080' }}
                            >
                              {item.price} {getSymbolFromCurrency(currency || 'USD')}
                            </span>
                          )}
                          {item.discount.enabled && (
                            <span className="bg-[#ff6600] text-white px-3 py-1 rounded-md text-base font-semibold">
                              {item.discount.discount_value} %
                            </span>
                          )}
                        </div>
                      ) : null}
                    </div>
                  </div>

                  {/* Mobile Layout */}
                  <div className="block md:hidden">
                    {/* Top Row: Number and Action Icons */}
                    <div className="flex items-center justify-between mb-4">
                      <div
                        className="text-white flex items-center justify-center text-xs rounded-md"
                        style={{ width: '24px', backgroundColor: '#333c47', height: '24px' }}
                      >
                        {index + 1}
                      </div>
                      <div className="flex items-center gap-2">
                        <img
                          src={shareIcon}
                          alt="share"
                          className="w-6 h-6 object-cover cursor-pointer"
                        />
                        <img
                          src={favoriteIcon}
                          alt="favorite"
                          className="w-6 h-6 object-cover cursor-pointer"
                        />
                        <img
                          src={deleteIcon}
                          alt="delete"
                          className="w-6 h-6 object-cover cursor-pointer"
                          onClick={() =>
                            updateUserCart(
                              item._id,
                              0,
                              item?.is_variation_product ? item?.variation_id : '',
                            )
                          }
                        />
                      </div>
                    </div>

                    {/* Image and Details Row */}
                    <div className="flex gap-4">
                      {/* Product Image */}
                      <div className="bg-white rounded-lg flex items-center justify-center w-20 h-20 flex-shrink-0">
                        <CustomImage
                          imageUrl={getTemplateImage(getProductImage(item.img_s3_keys))}
                          imgAlt={item.title}
                          imgClass="w-full h-full object-contain p-2"
                          onClickRedirect={() => navigate(`/product/${item._id}`)}
                        />
                      </div>

                      <div className="flex-1">
                        <p className="text-white font-semibold text-xs mb-2 line-clamp-2">
                          {item.title}
                        </p>

                        <div className="flex  gap-2 mb-3">
                          <div className="flex items-center gap-2">
                            <span className="text-white text-[10px]">Quantity:</span>
                            <select
                              value={item.quantity}
                              onChange={(e) =>
                                updateUserCart(
                                  item._id,
                                  parseInt(e.target.value),
                                  item?.is_variation_product ? item?.variation_id : '',
                                )
                              }
                              className="bg-transparent text-white px-2 py-1 rounded text-[10px]"
                              style={{ border: 'solid 0.5px #ccc' }}
                            >
                              {Array.from({ length: 10 }, (_, i) => i + 1).map((num) => (
                                <option key={num} value={num} className="text-black">
                                  {num}
                                </option>
                              ))}
                            </select>
                          </div>
                        </div>

                        <div
                          className="text-[10px] font-semibold mb-2"
                          style={{ color: item.in_stock ? '#52c90d' : '#ff4d4d' }}
                        >
                          {item.in_stock ? 'In Stock' : 'Out of Stock'}
                        </div>
                        {!isEmpty(item?.metadata) ? (
                          <div className="flex items-center">
                            {Object.keys(item?.metadata).map((key, index) => {
                              return (
                                <div
                                  className={index ? 'ml-2' : ''}
                                  style={{ color: '#d1d1d1' }}
                                  key={index}
                                >
                                  <span className="text-xs">
                                    {item?.metadata[key].name}: {item?.metadata[key].value}
                                  </span>
                                </div>
                              )
                            })}
                          </div>
                        ) : null}
                      </div>
                    </div>

                    {/* Price Row */}
                    <div className="mt-4 flex items-center gap-2">
                      <span className="text-[10px]" style={{ color: '#979797' }}>
                        Price:
                      </span>
                      <span className="text-white text-base font-semibold">
                        {item.discount.enabled
                          ? parseFloat(
                              item.price - (item.price * item.discount.discount_value) / 100,
                            ).toFixed(2)
                          : parseFloat(item.price).toFixed(2)}
                      </span>
                      <span className="text-white text-xs  uppercase">
                        {getSymbolFromCurrency(currency || 'USD')}
                      </span>
                      {item.discount.enabled && (
                        <span className="line-through mt-2 text-xs" style={{ color: '#808080' }}>
                          {item.price} {getSymbolFromCurrency(currency || 'USD')}
                        </span>
                      )}
                      {item.discount.enabled && (
                        <span className="bg-[#ff6600] text-white px-2 py-1 rounded-md text-xs font-semibold">
                          {item.discount.discount_value} %
                        </span>
                      )}
                    </div>
                  </div>
                </div>
              ))}

              {/* Shipping Address - Mobile toggle */}
              {showAddress && (
                <div
                  className="lg:hidden rounded-lg p-6 mt-5"
                  style={{ backgroundColor: '#1d2a39' }}
                >
                  <div className="flex justify-between items-center mb-3">
                    <p className="text-white font-semibold text-base">Your Shipping Address</p>
                  </div>
                  <div className="text-xs">
                    {!isEmpty(selectedAddress) ? (
                      Object.keys(selectedAddress)
                        .filter((e) => e !== 'id' && e !== 'default')
                        .map((key, index) => (
                          <div key={index} className="flex">
                            <span className="w-20 mb-2.5" style={{ color: '#979797' }}>
                              {snakeToTitle(key)}
                            </span>
                            <span className="text-white">{selectedAddress[key]}</span>
                          </div>
                        ))
                    ) : (
                      <div
                        className=" p-5 flex flex-col items-center justify-center cursor-pointer"
                        onClick={() => navigate('/manage-address')}
                      >
                        <img src={addIcon} alt="add" className="w-10 h-10 mb-3" />
                        <p className="text-sm  leading-[1.57]" style={{ color: '#979797' }}>
                          ADD NEW ADDRESS
                        </p>
                      </div>
                    )}
                  </div>
                </div>
              )}
            </div>

            {/* Right Side - Desktop Price & Address */}
            <div className="hidden lg:block">
              {/* Price Details */}
              <div className="rounded-lg p-6" style={{ backgroundColor: '#1d2a39' }}>
                <h3 className="text-white font-semibold text-base mb-4">
                  Price Details ({products?.length || 0} Items)
                </h3>
                <div className="mt-4">
                  <div className="flex justify-between items-center">
                    <p className="text-sm" style={{ color: '#a1a1a1' }}>
                      Total Price
                    </p>
                    <p className="text-sm" style={{ color: '#a1a1a1' }}>
                      {parseFloat(total_price).toFixed(2)}{' '}
                      {getSymbolFromCurrency(currency || 'USD')}
                    </p>
                  </div>
                  <div className="flex justify-between items-center mt-3">
                    <p className="text-sm" style={{ color: '#a1a1a1' }}>
                      Total Discount
                    </p>
                    <p className="text-sm" style={{ color: '#a1a1a1' }}>
                      - {parseFloat(total_discount).toFixed(2)}{' '}
                      {getSymbolFromCurrency(currency || 'USD')}
                    </p>
                  </div>
                  {isShippingChargesEnabled && !isEmpty(selectedShippingCharges) ? (
                    <div className="flex justify-between items-center mt-3">
                      <p className="text-sm" style={{ color: '#a1a1a1' }}>
                        Shipping Charges
                      </p>
                      <p className="text-sm" style={{ color: '#a1a1a1' }}>
                        + {parseFloat(selectedShippingCharges?.rate_amount).toFixed(2)}{' '}
                        {getSymbolFromCurrency(currency || 'USD')}
                      </p>
                    </div>
                  ) : null}

                  <hr className="border-gray-600 mt-3" />
                  <div className="flex justify-between items-center font-semibold mt-4">
                    <p className="text-white text-sm">Payable Amount</p>
                    <p className="text-white text-sm">
                      {isShippingChargesEnabled && !isEmpty(selectedShippingCharges)
                        ? parseFloat(total_payable + selectedShippingCharges?.rate_amount).toFixed(
                            2,
                          )
                        : parseFloat(total_payable).toFixed(2)}{' '}
                      {getSymbolFromCurrency(currency || 'USD')}
                    </p>
                  </div>
                </div>

                <button
                  className="mt-14 w-full mb-16   text-white font-semibold py-3 px-4 rounded-md "
                  style={{
                    backgroundImage: 'linear-gradient(93deg, #f60 6%, #ff4e00 97%)',
                    opacity: products?.length ? 1 : 0.8,
                  }}
                  disabled={!products?.length}
                  onClick={handlePlaceOrder}
                >
                  Place Order
                </button>
              </div>

              {/* Shipping Address */}
              <div className="rounded-lg p-6 mt-5" style={{ backgroundColor: '#1d2a39' }}>
                <div className="flex justify-between items-center mb-3">
                  <p className="text-white font-semibold text-base">Your Shipping Address</p>
                  {!isEmpty(selectedAddress) ? (
                    <img
                      src={editIcon}
                      alt="share"
                      className="w-6 h-6 object-cover cursor-pointer"
                      onClick={() => setOpenAddressModal(true)}
                    />
                  ) : null}
                </div>
                <div className="text-xs">
                  {!isEmpty(selectedAddress) ? (
                    Object.keys(selectedAddress)
                      .filter((e) => e !== 'id' && e !== 'default')
                      .map((key, index) => (
                        <div key={index} className="flex">
                          <span className="w-20 mb-2.5" style={{ color: '#979797' }}>
                            {snakeToTitle(key)}
                          </span>
                          <span className="text-white">{selectedAddress[key]}</span>
                        </div>
                      ))
                  ) : (
                    <div
                      className=" p-5 flex flex-col items-center justify-center cursor-pointer"
                      onClick={() => navigate('/manage-address')}
                    >
                      <img src={addIcon} alt="add" className="w-10 h-10 mb-3" />
                      <p className="text-sm  leading-[1.57]" style={{ color: '#979797' }}>
                        ADD NEW ADDRESS
                      </p>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        )}
      </div>

      {shareModal && (
        <ShareModal
          onClose={() => setShareModal(false)}
          link={create_share_url()}
          detailObj={{}}
          onlyShareLink={true}
        />
      )}
      {openAddressModal && (
        <AddressModal
          onClose={() => setOpenAddressModal(false)}
          setAddress={(data) => setSelectedAddress(data)}
          data={selectedAddress}
        />
      )}
    </div>
  )
}

export default CartDetails
